/*  eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './CatelogueItem.css';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modals/Modal';
import ResourceModal from './Modals/ResourceModal';

function Resource({ curriculum, setCurriculum, lessonParent, isUploadingViaApi, setIsUploadingViaApi }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="CIT NotYetAvailable" onClick={() => setIsOpen(true)}>
        <div className="CIT_A1">
          <FontAwesomeIcon icon={faPaperclip} />
        </div>
        <div className="CIT_A2">
          Resource
        </div>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
        <ResourceModal />
      </Modal>
    </div>
  );
}

export default Resource;
/*  eslint-enable no-unused-vars */
